import { AxiosError } from '@mint-lib/api';

export const isAxiosError = (error: unknown): error is AxiosError => {
  if (!error || typeof error !== 'object') {
    return false;
  }

  return 'name' in error && error.name === 'AxiosError';
};
